import React from 'react';
import {Alert, Badge, Form, Icon, Input, InputNumber, Button, Select, Row, Col, Steps, Transfer } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  updateSimulationRequest,
  createSimulationRequest,
  getSettingsUsersRequest,
  getSitesRequest
} from "../../api/requests";
import {
  getSimulationCreatePermission,
  getSimulationUpdatePermission
} from "../../reducers/user/selectors";

import classes from './SimulationForm.css';
import { logout } from "../../reducers/user/actions";

const { Option } = Select;
const { Step } = Steps;

class SimulationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      usersList: [],
      userTargetKeys: props.user_ids || [],
      siteList: [],
      siteTargetKeys: props.site_ids || [],
      requestResult: {},
      currentStep: 0,
      currentUserPage: 1,
      total: 1,
      pageUserSize: 1000,
      name: '',
    };
  }

  componentDidMount() {
    this.getUsersList();
    this.getSitesList();
  }

  getUsersList = async (page = this.state.currentUserPage) => {
    try {
      const { data } = await getSettingsUsersRequest({ page, per_page: this.state.pageUserSize });
      this.setState({ usersList: data.data.map(user => ({ key: user.id, title: user.username, description: user.username, chosen: false })), total: data.total_pages * this.state.pageUserSize, currentUserPage: page });
    } catch (e) {
      console.log(e);
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
    }
  };

  getSitesList = async () => {
    try {
      const { data } = await getSitesRequest();
      this.setState({ siteList: data.map(site => ({ key: site.id, title: `${site.code} - ${site.name}` })) });
    } catch (e) { if (get(e, 'response.status') === 401) { this.props.logout();  return; } console.log(e);}
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const simulation = {...values};

          simulation.name = this.state.name;
          simulation.user_ids = this.state.userTargetKeys;
          simulation.site_ids = this.state.siteTargetKeys;

          if (this.props.id) {
            await updateSimulationRequest(this.props.id , simulation);
          } else {
            await createSimulationRequest(simulation);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onPrev = () => {
    this.setState(state => ({ currentStep: state.currentStep - 1 }));
  };

  onNext = async () => {
    const { validateFields, getFieldValue } = this.props.form;

    const name = getFieldValue('name') || this.state.name;

    try {
      await validateFields();
      this.setState(state => ({ currentStep: state.currentStep + 1, name }));
    } catch (e) {}
  };

  handleTransferChange = targetName => targetKeys => {
    this.setState({ [targetName]: targetKeys });
  };

  render() {
    const { isLoading, requestResult, currentStep, usersList, userTargetKeys, siteList, siteTargetKeys } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { simulationUpdatePermission, simulationCreatePermission, id, isNew } = this.props;

    const isEditable = id ? simulationUpdatePermission : simulationCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} <Badge count='Edit' style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? 'Add simulation' : ''}
          </h4>

          <br/>

          <Steps current={currentStep}>
            <Step title="Step 1" description="Edit name" />
            <Step title="Step 2" description="Sites and users" />
            <Step title="Step 3" description="Edit simulation" />
          </Steps>

          <br/>

          {currentStep === 0 && <div>
            <Row gutter={12}>
              <Col span={12}>
                <label>
                  <b>Name:</b>
                  <Form.Item>
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.state, 'name') || get(this.props, 'name', '')
                    })(
                      <Input disabled={!isEditable} placeholder='Name' />
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          </div>}

          {currentStep === 1 && <div>
            <Row gutter={12}>
              <Col>
                <div>
                  <b>Select users:</b>
                  <Form.Item>
                    {getFieldDecorator('user_ids', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: this.state.userTargetKeys && this.state.userTargetKeys.length > 0 ? this.state.userTargetKeys : get(this.props, 'user_ids', '')
                    })(
                      <Transfer
                        dataSource={usersList}
                        targetKeys={userTargetKeys}
                        onChange={this.handleTransferChange('userTargetKeys')}
                        showSearch
                        render={item => item.title}
                        listStyle={{
                          height: 250,
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col>
                <div>
                  <b>Select sites:</b>
                  <Form.Item>
                    {getFieldDecorator('site_ids', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: this.state.siteTargetKeys && this.state.siteTargetKeys.length > 0 ? this.state.siteTargetKeys : get(this.props, 'site_ids', '')
                    })(
                      <Transfer
                        dataSource={siteList}
                        targetKeys={siteTargetKeys}
                        onChange={this.handleTransferChange('siteTargetKeys')}
                        showSearch
                        render={item => item.title}
                        listStyle={{
                          height: 250,
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>}

          {currentStep === 2 && <div>
            <Row gutter={12}>
              <Col lg={12}>
                <label>
                  <b>Number of patients:</b>
                  <Form.Item>
                    {getFieldDecorator('subject_count', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'subject_count', '')
                    })(
                      <Input disabled={!isEditable} placeholder='Subject count' />
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col lg={12}>
                <label>
                  <b>Number of Simulations:</b>
                  <Form.Item>
                    {getFieldDecorator('simulation_count', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'simulation_count', '')
                    })(
                      <Input disabled={!isEditable} placeholder='Simulation count' />
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col lg={12}>
                <label>
                  <b>Min weight:</b>
                  <Form.Item>
                    {getFieldDecorator('min_weight', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'min_weight', '')
                    })(
                      <InputNumber disabled={!isEditable} placeholder='Simulation count' />
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col lg={12}>
                <label>
                  <b>Max weight:</b>
                  <Form.Item>
                    {getFieldDecorator('max_weight', {
                      rules: [{ required: true }],
                      initialValue: get(this.props, 'max_weight', '')
                    })(
                      <InputNumber disabled={!isEditable} placeholder='Simulation count' />
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col lg={12}>
                <label>
                  <b>Status:</b>
                  <Form.Item>
                    {getFieldDecorator('status', {
                      rules: [{ required: true, message: 'Required' }],
                      initialValue: get(this.props, 'status', 'not_started')
                    })(
                      <Select placeholder='Select'>
                        <Option value="not_started">Draft</Option>
                        <Option value="ready">Ready</Option>
                        <Option disabled value="in_progress">In progress</Option>
                        <Option disabled value="completed">Completed</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          </div>}

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && currentStep !== 0 && (<Form.Item>
              <Button type="default" htmlType="button" className={classes.submitButton} onClick={this.onPrev}>
                Prev
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}
            {isEditable && currentStep === 2 && (<Form.Item>
              <Button type="primary" htmlType="submit" className={classes.submitButton}>
                Save
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}
            {isEditable && currentStep !== 2 && (<Form.Item>
              <Button type="primary" htmlType="button" className={classes.submitButton} onClick={this.onNext}>
                Next
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Form.Item>
              <Button type="default" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  simulationCreatePermission: getSimulationCreatePermission(state),
  simulationUpdatePermission: getSimulationUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'simulation' })(connect(mapStateToProps, mapDispatchToProps)(SimulationForm));



// WEBPACK FOOTER //
// ./src/components/SimulationForm/SimulationForm.js